<template>
  <div class="profile content-width">
    <h1><i class="el-icon-message"></i>&nbsp;{{ (showVerification) ? 'Verify your' : 'Add your' }} email address</h1>

    <div v-if="showVerification">
      <p>
        A verification email has been sent to <strong>{{ unverifiedEmail }}</strong>.<br>
        Please check your inbox and follow the instruction inside the email to
        complete the sign up process.
      </p>

      <div class="profile__problem">
        <p>
          <small>Didn't receive your email?</small>
        </p>
        <el-button-group>
          <el-button size="mini" icon="el-icon-arrow-left" @click="showVerification = false">
            Change your email
          </el-button>
          <el-button size="mini" @click="resendVerificationEmail">
            Resend verification email
          </el-button>
        </el-button-group>
      </div>
    </div>
    <div v-else>
      <p>
        To create your Viddsee creator account and to keep you updated on your
        film, we will need your email address. Please enter your email below:
      </p>

      <el-form
        ref="form"
        :model="form"
        :rules="rules"
      >
        <el-form-item prop="email">
          <el-input
            required
            type="email"
            v-model="form.email"
            placeholder="Please enter a valid email address"
          >
            <el-button
              :loading="loading.updatingEmail"
              slot="append"
              @click="submit"
            >Add</el-button>
          </el-input>
        </el-form-item>
      </el-form>
    </div>

  </div>
</template>

<script>
import NOTIFY_CONSTANTS from '@/config/notify-constants';
import webcall from '@/libs/webcall';

export default {
  data() {
    return {
      form: {
        email: '',
      },
      rules: {
        email: [
          { type: 'email', required: true, message: 'Please enter a valid email address', trigger: 'blur' },
        ],
      },
      showVerification: false,
      loading: {
        updatingEmail: false,
        sendingVerification: false,
      },
    };
  },
  computed: {
    needEmail() {
      return this.$store.state.account.shouldAskForAddingEmail;
    },
    needVerification() {
      return this.$store.state.account.shouldAskForVerification;
    },
    unverifiedEmail() {
      return this.$store.state.account.blob.unverified_email;
    },
  },
  methods: {
    submit() {
      this.$refs.form.validate()
        // Stop execution if form is not valid
        .catch(() => {
          const errorMessage = 'Please enter a valid email address';
          this.$alert(errorMessage, 'Error', {
            confirmButtonText: 'OK',
          });
          throw new Error(errorMessage);
        })
        .then(() => {
          this.loading.updatingEmail = true;
          return webcall.user.updateEmail(this.form)
            .catch(({ data }) => {
              const errorMessage = data.error ||
            'We are unable to update the email now. Please check your internet connection or contact support.';
              this.$alert(errorMessage, 'Opps');
              this.loading.updatingEmail = false;
            });
        })
        .then(() => {
          this.loading.updatingEmail = false;
          return this.$store.dispatch('account/initialiseAccount')
            .then(() => {
              this.showVerification = this.needVerification;
            });
        })
        .catch(() => {
          this.loading.updatingEmail = false;
        });
    },
    resendVerificationEmail() {
      this.loading.sendingVerification = true;
      webcall.user.sendVerificationEmail()
        .then(() => {
          this.loading.sendingVerification = false;
        })
        .catch((error) => {
          this.$notify.error({
            title: 'Unable to resend verification',
            message: 'Please check your connection or try again later.',
            duration: NOTIFY_CONSTANTS.DURATION.FOREVER,
          });
          this.loading.sendingVerification = false;
        });
    },
  },
  mounted() {
    this.form.email = this.unverifiedEmail;
    this.showVerification = this.needVerification;
  },
};
</script>

<style lang="scss">
.profile__problem {
  margin-top: 4em;

  > p {
    margin-bottom: 0.5em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Profile/Signup/SignupEmail.vue